export default "__VITE_ASSET__CVaJDmrW__"